import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { AutoScrollTopComponent } from "../../components/auto-scroll-top.component";
import { ServiceCoverComponent } from "../components/service-cover.component";
import { getiService, IService } from "../../data";
import { ContactContainerComponent } from "../../contact/contact-container.component";
import { IndexServiceCardComponent } from "../components/index-service-card.component";
import { DualEmploymentComponent } from "../background-verification/components/dual-employment.component";
import { WhyChooseBGVComponent } from "../background-verification/components/why-choose-bgv.component";

interface IIndexServiceComponentProps {}

export const IndexServicePage: React.FC<IIndexServiceComponentProps> = (
    props: IIndexServiceComponentProps
) => {
    const params = useParams();
    const iservice = getiService(params.service || "");
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    useEffect(() => setActiveTabIndex(0), [iservice?.id]);

    if (!iservice) return <></>;

    return (
        <>
            <AutoScrollTopComponent changeDetector={iservice} />
            <ServiceCoverComponent
                backgroundImage={iservice.coverImage}
                title={iservice.title}
                subTitle=""
                urls={[
                    { label: "Services", path: "/home#services" },
                    {
                        label: iservice.title || "",
                        path: iservice.route,
                    },
                ]}
            />
            {iservice.id === "background-verification" && (
                <div
                    className="container pt-4 text-center"
                    data-aos="fade-up"
                    data-aos-delay="100"
                >
                    <button
                        type="button"
                        className={`btn btn-outline-${
                            activeTabIndex === 0 ? "danger" : "secondary"
                        } btn-sm`}
                        onClick={() => setActiveTabIndex(0)}
                    >
                        Services
                    </button>
                    &nbsp;&nbsp;
                    <button
                        type="button"
                        className={`btn btn-outline-${
                            activeTabIndex === 1 ? "danger" : "secondary"
                        } btn-sm`}
                        onClick={() => setActiveTabIndex(1)}
                    >
                        Why Choose BGV
                    </button>
                    &nbsp;&nbsp;
                    <button
                        type="button"
                        className={`btn btn-outline-${
                            activeTabIndex === 2 ? "danger" : "secondary"
                        } btn-sm`}
                        onClick={() => setActiveTabIndex(2)}
                    >
                        Dual Employment
                    </button>
                </div>
            )}

            {activeTabIndex === 0 && (
                <section id="services" className="services section">
                    <div className="container">
                        <div className="row gy-4">
                            {iservice.services.map(
                                (service: IService, index: number) => {
                                    return (
                                        <IndexServiceCardComponent
                                            key={service.id}
                                            title={service.title}
                                            subtitle={service.subtitle}
                                            delay={100 * (index + 1)}
                                            route={service.route}
                                            description={service.description}
                                            collg={iservice.collg}
                                            colmd={iservice.colmd}
                                        />
                                    );
                                }
                            )}
                        </div>
                    </div>
                </section>
            )}
            {activeTabIndex === 1 && <WhyChooseBGVComponent />}
            {activeTabIndex === 2 && <DualEmploymentComponent />}

            <ContactContainerComponent />
        </>
    );
};
